"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _billButtons = _interopRequireDefault(require("@/views/userCenter/componens/billButtons.vue"));
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _billConsigneeApplication = require("@/api/userCenter/billConsigneeApplication");
var _index3 = _interopRequireDefault(require("@/components/BackToTop/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { Descriptions ,DescriptionsItem } from 'element-ui';
var _default = exports.default = {
  name: "",
  components: {
    BackToTop: _index3.default,
    filterColumn: _index.default,
    billButtons: _billButtons.default,
    Pagination: _index2.default
    // Descriptions,DescriptionsItem
  },
  data: function data() {
    return {
      tableCostData: [],
      hotSettings: {
        dragCheck: true,
        height: '500',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      tableListNY: [{
        value: '0',
        label: 'No'
      }, {
        value: '1',
        label: 'Yes'
      }],
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      tableData: {},
      detailInfo: {
        sizeType: '',
        unit: ''
      }
    };
  },
  created: function created() {
    this.tableData = this.$route.query.tableData;
    if (this.tableData.fr20 == '1') {
      this.detailInfo.sizeType = '20FR';
      this.detailInfo.unit = '1';
    }
    if (this.tableData.fr40 == '1') {
      this.detailInfo.sizeType = '40FR';
      this.detailInfo.unit = '1';
    }
    if (this.tableData.gp40 == '1') {
      this.detailInfo.sizeType = '40GP';
      this.detailInfo.unit = '1';
    }
    if (this.tableData.hc40 == '1') {
      this.detailInfo.sizeType = '40HC';
      this.detailInfo.unit = '1';
    }
    if (this.tableData.hr40 == '1') {
      this.detailInfo.sizeType = '40HR';
      this.detailInfo.unit = '1';
    }
    if (this.tableData.ot20 == '1') {
      this.detailInfo.sizeType = '20OT';
      this.detailInfo.unit = '1';
    }
    if (this.tableData.ot40 == '1') {
      this.detailInfo.sizeType = '40OT';
      this.detailInfo.unit = '1';
    }
    console.log('this.tableData', this.tableData);
  },
  mounted: function mounted() {
    this.handleLoadByBlNo();
  },
  methods: {
    handleLoadByBlNo: function handleLoadByBlNo() {
      var _this = this;
      (0, _billConsigneeApplication.loadByBlNo)(this.tableData.blNo).then(function (res) {
        console.log('res', res);
        if (res.success) {
          _this.tableData.vesselName = res.data.vesselName;
          _this.tableData.voyageNo = res.data.voyageNo;
          _this.tableData.pol = res.data.pol;
          _this.tableData.pod = res.data.pod;
          _this.tableData.customerName = res.data.customerName;
          _this.tableData.consigneeCode = res.data.consigneeCode;
          _this.tableData.shipperCode = res.data.shipperCode;
          _this.tableData.dateOfPayment = res.data.dateOfPayment;
          _this.tableData.remark = res.data.remark;
          _this.tableData.changed = res.data.changed;
          _this.tableData.releaseTo = res.data.releaseTo;
          _this.tableData.creditAgnDate = res.data.creditAgnDate;
          _this.tableData.creditCstDate = res.data.creditCstDate;
          _this.tableData.creditSitDate = res.data.creditSitDate;
        }
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    getTableListItem: function getTableListItem(value) {
      var lable = '';
      this.tableListNY.map(function (item, index) {
        if (value == item.value) {
          lable = item.label;
        }
      });
      return lable;
    },
    searchFormData: function searchFormData() {
      var _this2 = this;
      var data = this.searchForm;
      data.currentPage = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      console.log('this.searchForm', this.searchForm);
      (0, _billConsigneeApplication.searchWebBlConsigneeCertification)(data).then(function (res) {
        console.log('res', res);
        _this2.tableCostData = res.data.records;
        _this2.listQuery.total = res.data.totalRecord;
        _this2.selectionIds = [];
        console.log(' this.tableCostData', _this2.tableCostData);
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    hotTableSelect: function hotTableSelect(data) {
      console.log('data', data);
      var array = [];
      var arrayStatus = [];
      this.$refs.hotTableCost.getSelections().forEach(function (e) {
        array.push(e.blConsigneeCertificationId);
        arrayStatus.push({
          status: e.status
        });
      });
      this.selectionIds = array;
      this.tableDataStutus = arrayStatus;
      console.log('this.selectionIds', this.selectionIds);
      console.log('tableDataStutus', this.tableDataStutus);
    },
    getDetailsData: function getDetailsData() {
      this.$router.push({
        path: '/settlementManagement/monthCostManagementJPDetail'
      });
    }
  }
};